import { styled, Grid, Fade, Box, Typography } from '@mui/material'
import { useGames } from 'state/games/hooks'
import LinkIcon from 'assets/images/svg/common/link.svg'
import { convertImage } from 'utils'
import { useEffect, useMemo, useState } from 'react'
const Wrapper = styled(Fade)`
  position: absolute;
  top: 56px;
  left: 0;
  background: ${props => props.theme.colors.black};
  z-index: 99999;
  transition: all(0.5s);
  max-height: 100vh;
  overflow-y: auto;
  width: 100%;
  display: flex;
  .MuiGrid-item {
    flex: 1 0 33.3333%;
  }
`
const OtherContent = styled(Box)`
  height: 18.75vw;
  width: 100%;
  filter: drop-shadow(0px 20px 40px rgba(0, 0, 0, 0.5));
  background-size: 100%;
  background-position: bottom;
  transition: all 200ms;
  background-repeat: no-repeat;
  .MuiTypography-root {
    :hover {
      background-size: 110%;
      img {
        opacity: 1;
        transform: translateX(0);
      }
    }
  }

  img {
    opacity: 0;
    transform: translateX(-100%);
    transition: all 200ms;
  }
`
const Content = styled(Box)`
  height: 18.75vw;
  width: 100%;
  filter: drop-shadow(0px 20px 40px rgba(0, 0, 0, 0.5));
  background-size: 100%;
  background-position: bottom;
  transition: all 200ms;
  background-repeat: no-repeat;
  .MuiBox-root {
    position: absolute;
    left: 40px;
    bottom: 40px;
  }
  :hover {
    background-size: 110%;
    img {
      opacity: 1;
      transform: translateX(0);
    }
  }
  img {
    opacity: 0;
    transform: translateX(-100%);
    transition: all 200ms;
  }
`
export default function Games({ open, clickItem }: { open: boolean; clickItem: () => void }) {
  const { games } = useGames()
  const [imgUrl, setImgUrl] = useState<string>('')

  const isStaging = window.location.host.indexOf('web.staging') > -1
  const remainingGames = useMemo(() => {
    if (games.length > 2) {
      return games ? games.slice(2, games.length > 5 ? 5 : games.length) : []
    } else {
      return []
    }
  }, [games])
  useEffect(() => {
    if (games.length > 2) {
      setImgUrl(games[2].cover)
    }
  }, [games])
  return (
    <Wrapper in={open}>
      <Grid columns={{ xs: 4 }}>
        {games &&
          games.slice(0, 2).map((el: any, k: number) => {
            return (
              <Grid
                key={'og' + k}
                item
                xs={3}
                onClick={() => {
                  window.location.href = `/game/${el.gameAlias}`
                }}
              >
                <Content
                  padding="40px"
                  key={'og' + k}
                  onClick={clickItem}
                  sx={{
                    backgroundImage: `linear-gradient(360deg, #000000 0%, rgba(0, 0, 0, 0) 41.64%),
linear-gradient(131.79deg, rgba(0, 0, 0, 0.3) 28.09%, rgba(0, 0, 0, 0) 86.56%), url(${
                      isStaging ? el.cover : convertImage(el.cover, 500, 0)
                    })`,
                  }}
                >
                  <Typography
                    fontWeight="700"
                    fontFamily="'Roboto Condensed', sans-serif"
                    fontSize="48px"
                    lineHeight="48px"
                    width="160px"
                  >
                    {el.title}
                  </Typography>
                  <Box width="40px" overflow="hidden">
                    <img alt="" src={LinkIcon}></img>
                  </Box>
                </Content>
              </Grid>
            )
          })}
        <OtherContent
          width="100%"
          sx={{
            backgroundImage: imgUrl
              ? `linear-gradient(250.01deg, rgba(0, 0, 0, 0) -1.92%, rgba(0, 0, 0, 0.5) 94.87%), linear-gradient(250.01deg, rgba(0, 0, 0, 0) -1.92%, #000000 94.87%), url(${imgUrl})`
              : 'none',
          }}
        >
          {remainingGames.map((el, index) => (
            <Typography
              key={`remainingGames${el.id}${index}`}
              margin="40px"
              fontWeight="700"
              fontFamily="'Roboto Condensed', sans-serif"
              fontSize="32px"
              lineHeight="36px"
              display="flex"
              alignItems="center"
              onClick={() => {
                window.location.href = `/game/${el.gameAlias}`
              }}
              onMouseLeave={() => {
                setImgUrl(remainingGames && remainingGames.length > 0 ? remainingGames[0].cover : '')
              }}
              onMouseEnter={() => {
                setImgUrl(el.cover)
              }}
            >
              {el.title}
              <img
                alt=""
                src={LinkIcon}
                width="40px"
                style={{
                  marginLeft: '12px',
                }}
              ></img>
            </Typography>
          ))}
        </OtherContent>
      </Grid>
    </Wrapper>
  )
}
